module.exports = __webpack_public_path__ + "img/img21.a8a0c19a.jpg";